<template>
  <component
    :is="component"
    :class="b(mods)"
    :disabled="disabledInternal"
    v-bind="$attrs"
  >
    <span :class="b('content')">
      <ga-icon :class="b('icon')">
        <slot name="icon" />
      </ga-icon>
    </span>
  </component>
</template>

<script src="./button-icon-only.script.js" />

<style module src="./button-icon-only.style.scss" lang="scss" />
